import {
    ACTIVITY,
    ADD_RIGHTS,
    APPROVED,
    AVAILABLE,
    BOOKLISTS_ACTIVE,
    BOOKLISTS_ALL,
    BOOKLISTS_ARCHIVED,
    CANCELLED,
    DENIED,
    EXISTING_PUBLISHERS,
    FULFILLMENT,
    INFO_NEEDED,
    NEEDS_ATTENTION,
    NEEDS_MATCH,
    NEW,
    NEW_PUBLISHERS,
    NOT_FOUND,
    NP_NEW,
    NP_PROCESSING,
    NP_WAITING_LEGAL,
    ONBOARDING,
    ON_HOLD,
    PENDING,
    PROCESSING,
    PUBLISHER_REVIEW,
    PURGATORY,
    REQUEST,
    REQUESTED,
    REQUEST_RIGHTS,
    RETIRED,
    SUBMITTED,
    SUBSTITUTED,
    UNAVAILABLE,
    WAITING_CUSTOMER,
    WAITING_INSTITUTION,
    WAITING_LEGAL,
    WAITING_PUBLISHER
} from "@legacy/helpers/constants/sharedStatics";

export const statusesText = {
    ALL:'All Books',
    ACTIVITY:'Activity',
    ADD_RIGHTS: 'Adopt',
    AVAILABLE: 'Available',
    DENIED: 'Denied Requests',
    FULFILLMENT: 'Fulfillment',
    INFO_NEEDED: 'Info Needed',
    NEEDS_ATTENTION: 'Needs Attention',
    NEEDS_MATCH: 'Needs Match',
    NOT_FOUND:'Not Found',
    PENDING: 'Pending',
    PUBLISHER_REVIEW: 'Publisher Review',
    PURGATORY: 'Pending',
    REQUEST: 'Request',
    REQUESTED: 'Submitted Requests',
    REQUEST_RIGHTS: 'Request Rights',
    RETIRED: 'Retired',
    SUBMITTED: 'VitalSource Review',
    SUBSTITUTED: 'Substituted',
    UNAVAILABLE: 'Unavailable'
};

export const rightsRequestsStatusesText = {
    ACTIVITY:'Activity',
    APPROVED:'Approved',
    CANCELLED: 'Cancelled',
    DENIED: 'Denied',
    EXISTING_PUBLISHERS: 'Existing Publishers',
    NEEDS_MATCH: 'Needs Match',
    NEW:'New',
    NP_NEW: 'New',
    NEW_PUBLISHERS: 'New Publishers',
    ONBOARDING: 'Onboarding',
    ON_HOLD:'Hold',
    PENDING: 'Pending',
    PROCESSING:'Processing',
    NP_PROCESSING: 'Processing',
    WAITING_CUSTOMER:'Waiting - Customer',
    WAITING_INSTITUTION:'Waiting - Institution',
    WAITING_LEGAL:'Waiting - Legal',
    NP_WAITING_LEGAL:'Waiting - Legal',
    WAITING_PUBLISHER:'Waiting - Publisher',
};

export default {
    ACTIVE: BOOKLISTS_ACTIVE,
    ACTIVITY,
    ADD_RIGHTS,
    ALL: BOOKLISTS_ALL,
    APPROVED,
    ARCHIVED: BOOKLISTS_ARCHIVED,
    AVAILABLE,
    CANCELLED,
    DENIED,
    EXISTING_PUBLISHERS,
    FULFILLMENT,
    INFO_NEEDED,
    NEEDS_ATTENTION,
    NEEDS_MATCH,
    NEW,
    NEW_PUBLISHERS,
    NOT_FOUND,
    NP_NEW,
    NP_PROCESSING,
    NP_WAITING_LEGAL,
    ONBOARDING,
    ON_HOLD,
    PENDING,
    PROCESSING,
    PUBLISHER_REVIEW,
    PURGATORY,
    REQUEST,
    REQUESTED,
    REQUEST_RIGHTS,
    RETIRED,
    SUBMITTED,
    SUBSTITUTED,
    UNAVAILABLE,
    WAITING_CUSTOMER,
    WAITING_INSTITUTION,
    WAITING_LEGAL,
    WAITING_PUBLISHER
};